export const mbpAppFeatures = [
  'appointment',
  'recycle',
  'report',
  'collect-user-data',
  'report-roads-traffic',
];
